import type { SocialBet } from 'src/types/domain/SocialBet'
import type { Marble } from 'src/types/domain/Marble'
import { MarbleItem } from 'src/components/MarbleItem'
import { BetHistorySelectedMarbles } from 'src/components/BetHistoryPanel/components/BetHistorySelectedMarbles'
import { BirdieFeedPick } from 'src/components/BirdieBoard/BirdieFeedPick'
import { SimpleMarbleItem } from './SimpleMarbleItem'

type Props = Readonly<{
  bet: SocialBet
  selectedMarbles: Marble[]
  selectedItems: string[]
  simple?: boolean
  /**
   * The game is Birdie Time (B22). Its selected "marbles" are option rows whose
   * colour is a canonical key with no marble drawing behind it, so the pick is
   * drawn in the board's own vocabulary instead. Defaults to false: every
   * existing caller renders exactly what it rendered before the prop existed.
   */
  isBirdie?: boolean
}>

export function BetMarbles({
  bet,
  selectedMarbles,
  selectedItems,
  simple,
  isBirdie = false
}: Props) {
  if (isBirdie) {
    return selectedMarbles.map((marble) => <BirdieFeedPick key={marble.uuid} marble={marble} />)
  }

  if (selectedMarbles.length === 0) return null
  const betInExactOrder = ['StraightForecast', 'Tricast'].includes(bet.betDetails.type)

  if (bet.betDetails.type === 'PickWinner') {
    return selectedMarbles.map((marble) => (
      <div className="marble-wrapper" key={marble.uuid}>
        <MarbleItem className="marble-item" marble={marble} />
      </div>
    ))
  }

  return (
    <div className="marbles">
      <div
        className={`${simple ? 'show-single-position-simple' : 'choose-marbles-order show-single-position-compact'}`}
      >
        {selectedMarbles.map((marble) => {
          if (simple) {
            return <SimpleMarbleItem key={marble.uuid} marble={marble} />
          }

          const position = selectedItems.indexOf(marble.uuid) + 1

          return (
            <BetHistorySelectedMarbles
              exactOrder={betInExactOrder}
              isRaceEnded={false} // Social bets don't have race status
              key={marble.uuid}
              length={selectedMarbles.length}
              marble={marble}
              position={position}
            />
          )
        })}
      </div>
    </div>
  )
}
